import React from "react";
import cx from "classnames";

const Progressbar = ({ current, max, className }: { current: number; max: number; className?: string }) => {
	if (current === null || max === null) {
		return null;
	}
	if(max === 0){
		max = 1;
	}
	let width = Math.abs((current / max) * 100);
	return (
		<div className={cx("progressBar", className)}>
			<div className="value" style={{ width: width + "%" }}></div>
		</div>
	);
};

export default Progressbar;
